import { IconProps, iconA11yProps } from '../types';

export const SurveyStart = ({ classNames, label }: IconProps) => (
    <svg
        className={`relative ${classNames}`}
        id="icon-surveystart"
        width="96"
        height="96"
        viewBox="0 0 96 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...iconA11yProps(label)}
    >
        <g clipPath="url(#clip0)">
            <g className="motion-safe:animate-surveyStartIn origin-[200%_0]">
                <path
                    d="M21.5 24.5C14.8726 24.5 9.5 29.8726 9.5 36.5V61.5C9.5 68.1274 14.8726 73.5 21.5 73.5H67.5C74.1274 73.5 79.5 68.1274 79.5 61.5V36.5L88.0858 27.9142C89.3457 26.6543 88.4534 24.5 86.6716 24.5H21.5Z"
                    strokeWidth="3"
                />
                <path
                    d="M23.5639 42.0271C23.8633 41.1058 25.1667 41.1058 25.4661 42.0271L26.7612 46.0131H30.9523C31.921 46.0131 32.3238 47.2528 31.5401 47.8222L28.1494 50.2857L29.4445 54.2717C29.7439 55.193 28.6894 55.9591 27.9057 55.3897L24.515 52.9262L21.1243 55.3897C20.3406 55.9591 19.2861 55.193 19.5855 54.2717L20.8806 50.2857L17.4899 47.8222C16.7062 47.2528 17.109 46.0131 18.0777 46.0131H22.2688L23.5639 42.0271Z"
                    className="motion-safe:animate-surveyStartStar1 origin-[46%]"
                    strokeWidth="2"
                />
                <path
                    d="M43.5639 42.0271C43.8633 41.1058 45.1667 41.1058 45.4661 42.0271L46.7612 46.0131H50.9523C51.921 46.0131 52.3238 47.2528 51.5401 47.8222L48.1494 50.2857L49.4445 54.2717C49.7439 55.193 48.6894 55.9591 47.9057 55.3897L44.515 52.9262L41.1243 55.3897C40.3406 55.9591 39.2861 55.193 39.5855 54.2717L40.8806 50.2857L37.4899 47.8222C36.7062 47.2528 37.109 46.0131 38.0777 46.0131H42.2688L43.5639 42.0271Z"
                    className="motion-safe:animate-surveyStartStar2 origin-[46%]"
                    strokeWidth="2"
                />
                <path
                    d="M63.5639 42.0271C63.8633 41.1058 65.1667 41.1058 65.4661 42.0271L66.7612 46.0131H70.9523C71.921 46.0131 72.3238 47.2528 71.5401 47.8222L68.1494 50.2857L69.4445 54.2717C69.7439 55.193 68.6894 55.9591 67.9057 55.3897L64.515 52.9262L61.1243 55.3897C60.3406 55.9591 59.2861 55.193 59.5855 54.2717L60.8806 50.2857L57.4899 47.8222C56.7062 47.2528 57.109 46.0131 58.0777 46.0131H62.2688L63.5639 42.0271Z"
                    className="motion-safe:animate-surveyStartStar3 origin-[46%]"
                    strokeWidth="2"
                />
            </g>
        </g>
        <rect x="1.5" y="1.5" width="93" height="93" rx="16" strokeWidth="3" />
        <defs>
            <clipPath id="clip0">
                <rect x="1.5" y="1.5" width="93" height="93" rx="16" />
            </clipPath>
        </defs>
    </svg>
);
